import { mergeWith } from "lodash/fp";

export default mergeWith((a, b) => {
  if (Array.isArray(a) && Array.isArray(b)) {
    return [...a, ...b];
  }
});
